$('.trigger_use_text').click(function(){
$(this).toggleClass('active');
$(this).next().slideToggle();
});

$('.trigger_custom_animate, .trigger_custom_box a').click(function(e){
  e.preventDefault();
$('.buy_custom_animate').addClass('active');
});

$('.close_custom_custom_animate').click(function(e){
  e.preventDefault();
$('.buy_custom_animate').removeClass('active');
});
$('input[name="variant_id"]:not(.custom_input)').on('change',function(e){
var variant_id = $(this).val();
var id=$(this).attr('id');
if (id=="product2_variant_id"){
 $('.buy_now_image_item[data_tab="1"]').hide(); 
 $('.buy_now_image_item[data_tab="2"]').show();   
} else {
 $('.buy_now_image_item[data_tab="2"]').hide(); 
 $('.buy_now_image_item[data_tab="1"]').show();   
}
$('.buy_now_trigger').attr('url',variant_id);
});

$('.buy_now_trigger').on('click',function(e){
var link = $(this).attr('url');
location.href=link;
});


$('#product1_variant_id:not(.custom_input)').click(function(){
var link =$(this).attr('url');
location.href=link;
});
$('#product2_variant_id:not(.custom_input)').click(function(){
var link =$(this).attr('url');
location.href=link;
});
jQuery('.question_product,.faq_question').click(function(){
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
});



$('.buy_now_trigger_custsom').on('click',function(e){
var variant_id = $(this).parents('form').find('input.product-variant-id').val();
var quantity=$(this).parents('form').find('input.quantity__input').val();
var cart_link = '/cart/'+variant_id+':'+quantity;
location.href=cart_link;
});


$('.sticky_button_trigger').click(function(e){
  e.preventDefault();
  var this_element = $(this);
$('.product__info-wrapper .buy_buttons_main_product .product-form__submit').trigger('click');
this_element.addClass('loading');
this_element.find('.loading__spinner').removeClass('hidden');
 setTimeout(function () {
this_element.removeClass('loading');
this_element.find('.loading__spinner').addClass('hidden');
}, 2500);
});